import type { FC } from 'react'

import {
  LayoutProvider,
  MfeProvider,
  ReactQueryProvider,
  SessionDev,
  SessionPreview
} from '@arcotech-services/cms-core'

import AppRouter from '@/App/router'

import httpClient from '@/Common/configs/axios'

import type { AppProps } from './app.types'

const App: FC<AppProps> = ({ basename }) => {
  const isDevelopment = process.env.ENVIRONMENT === 'development'
  const Session = isDevelopment ? SessionDev : SessionPreview

  return (
    <ReactQueryProvider httpClient={httpClient}>
      <LayoutProvider>
        <Session>
          <MfeProvider>
            <AppRouter basename={basename} />
          </MfeProvider>
        </Session>
      </LayoutProvider>
    </ReactQueryProvider>
  )
}

export default App
